import { ChangeDetectionStrategy, Component, model } from "@angular/core";

import { ModalComponent } from "@shared/components/modal/modal.component";

import { BaseModalComponent } from "../base-modal.component";

@Component({
  selector: "component-image-preview-modal",
  imports: [ModalComponent],
  templateUrl: "./image-preview-modal.component.html",
  styleUrls: ["./image-preview-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImagePreviewModalComponent extends BaseModalComponent {
  readonly title = model<string>("Image preview");
  readonly src = model.required<string>();

  download(): void {
    const link = document.createElement("a");
    link.href = this.src();
    link.download = "image";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
